<template>
  <el-container>
    <!--左侧菜单-->
    <el-aside class="menu-aside" width="256px">

      <!--logo-->
      <div class="logo">
        <img src="../../assets/logo.png" alt="">
      </div>

      <el-menu :default-active="$route.path"
               :default-openeds="defaultOpeneds"
               background-color="rgb(214,214,214)"
               :router="true">
        <!--可折叠菜单-->
        <el-submenu v-for="(subItem,key1) in menuList" :key="key1"
                    v-if="!subItem.hidden && getMenuList(subItem.children).length>1"
                    :index="subItem.path">
          <template slot="title">
            <icon-svg :icon-class="subItem.icon"/>
            <span slot="title">{{subItem.meta.title}}</span>
          </template>
          <el-menu-item
              v-for="(menuItem,key2) in subItem.children"
              :key="key2"
              v-if="!menuItem.hidden"
              :index="menuItem.path"
              @click="changeActiveDate">{{menuItem.meta.title}}
            <sup v-if="checkNum[menuItem.meta.checkNum]"
                 class="my-badge">{{checkNum[menuItem.meta.checkNum]}}</sup>
          </el-menu-item>
        </el-submenu>
        <!--不可折叠菜单-->
        <el-menu-item
            v-else-if="!subItem.hidden"
            v-for="(menuItem,key2) in getMenuList(subItem.children)"
            :key="menuItem.path"
            :index="menuItem.path"
            @click="changeActiveDate">
          <icon-svg :icon-class="subItem.icon"/>
          <span slot="title">{{menuItem.meta.title}}</span>
        </el-menu-item>
      </el-menu>
    </el-aside>

    <el-container class="main-wrap">
      <el-header height="60px">
        <div class="main">
          <!--面包屑-->
          <Breadcrumb/>
          <!--用户信息-->
          <div class="user" v-if="uid">
            <el-badge :value="$store.state.message_total" :hidden="$store.state.message_total==0" class="msg-center">
              <router-link to="/matter/notice" class="blue">通知中心</router-link>
            </el-badge>

            <el-popover
              placement="top-start"
              width="150"
              trigger="hover">
              <div class="account-list">
                <div class="account-item red">你好，{{username}}</div>
                <div class="account-item cp logout"  @click="logout()">
                  <span>注销</span>
                  <i class="el-icon-arrow-right"></i>
                </div>
              </div>
              <div class="current-account-wrap" slot="reference">
                <img :src="head_img ? head_img : default_img">
              </div>
            </el-popover>
          </div>
        </div>
      </el-header>
      <el-main class="main-content" :style="{height:initMainBoxHeight}">
        <transition name="router" mode="out-in">
          <router-view :key="activeDate"/>
        </transition>
      </el-main>
    </el-container>
  </el-container>
</template>

<script>
  //引入base64转码器
// import {
//   Base64
// } from 'js-base64';
  import {apiLogout} from '@/api/login'
  import {mapState, mapMutations,mapActions} from 'vuex'
  import Cookies from 'js-cookie'
  import util from '@/base/js/util'
  import Breadcrumb from '@/components/breadcrumb'
  import { ifError } from 'assert';

  export default {
    data() {
      return {
        activeDate: '',
        account_list: [],
        account_img:'',
        default_img: require('@/assets/logo.png')
      }
    },
    computed: {
      initMainBoxHeight() {
        const Win_H = window.innerHeight
        // header高60 el-main的padding为20
        const loginBox_H = `${Win_H-60}px`
        return loginBox_H
      },
      checkNum() {
        return 1
      },
      menuList() {
        let menuList = this.$store.state.routes
        return menuList
      },
      defaultOpeneds() {
        let arr = []
        this.menuList.forEach((item) => {
          if (!item.hidden && this.getMenuList(item.children).length > 1) {
            arr.push(item.path)
          }
        })
        return arr
      },
      ...mapState({
        uid: state => state.userInfo.userinfo.id,
        username: state => state.userInfo.userinfo.username,
        head_img:state=>state.userInfo.userinfo.head_img,
      }),
    },
    created() {
      // this.$nextTick(() => {
      //   this._getUserInfo()
      // })
      if(this.uid){
        this.setMessageNum();
      }
    },
    methods: {
      ...mapActions({
        setMessageNum:'getMessageTotAsy',
        clearMessageNum:'clearMessageTotAsy'
      }),
      //获取可显示路由列表
      getMenuList(list) {
        return list.filter(item => !item.hidden)
      },
      changeActiveDate() {
        this.activeDate = new Date().getTime()
      },
      //跳转首页(用户未登录时，主页路由未加载，点击不跳转)
      goToIndex(){
        if (Cookies.get('token')){
          this.$router.push({
            path: '/'
          })
        }
      },
      //获取用户信息
      _getUserInfo() {
        return new Promise((resolve, reject) => {
          if (!Cookies.get('token')) return
          getUserInfo().then(res => {
            if (res.resultCode === '0') {
              this.updateUserInfo({
                ...res.result,
                token: Cookies.get('token')
              })
              resolve(res.result)
            } else {
              Cookies.set('PHPSESSION', '')
              Cookies.set('token', '')
              this.$router.push('/login')
            }
          })
        })
      },
      //退出
      logout() {
        apiLogout().then(res => {
          if (res.resultCode == 1) {
            this.$message.success(res.errorMsg);
            util.removeSession('userInfo');
            setTimeout(function () {
              location.reload()
            }, 500)
          } else {
            this.$message.error(res.errorMsg)
          }
        })
      },
      ...mapMutations({
        updateUserInfo: 'updateUserInfo'
      })
    },
    components:{
      Breadcrumb
    }
  }
</script>

<style lang="less" scoped>
  .menu-aside{
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    background-color: rgb(214,214,214);
    .el-menu{
      border-right: none;
    }
  }

  .logo{
    display: flex;
    align-items: center;
    justify-content: center;
    height: 60px;
    img{
      width: 160px;
    }
  }
  .main-wrap {
    margin-left: 256px;
  }

  .main-content{
    /*padding: 0;*/
    overflow-y: auto;
    box-sizing: border-box;
  }

  .my-badge {
    background-color: #f56c6c;
    border-radius: 10px;
    color: #fff !important;
    display: inline-block;
    font-size: 12px;
    height: 14px;
    line-height: 14px;
    padding: 0 5px;
    text-align: center;
    white-space: nowrap;
    position: relative;
    bottom: 1px;
  }

  .el-submenu [class^=font-icon-] {
    vertical-align: middle;
    margin-right: 5px;
    width: 24px;
    text-align: center;
    font-size: 18px;
  }

  .el-header {
    width: 100%;
    /*position: fixed;*/
    /*z-index: 100;*/
    background-color: #fff;
    border-bottom: #e6e6e6 solid 1px;
    padding: 0 40px;

    .main {
      height: 100%;
      display: flex;
      justify-content: space-between;
      align-items: center;

      h3 {
        font-size: 26px;
        font-weight: normal;

        .router-link-active {
          display: flex;
          align-items: center;
        }

      }
    }
    .logo {
      width: 160px;
      margin-right: 5px;
    }
    .logout {
      margin-left: 20px;
    }
    .user {
      display: flex;
      align-items: center;
    }
    .msg-center{
      margin-right: 40px;
    }
    .current-account-wrap {
      display: flex;
      align-items: center;
      font-weight: bold;
      img {
        width: 40px;
        height: 40px;
        border-radius: 50%;
        margin-right: 10px;
      }
    }
  }
  .account-list{
    .account-item{
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 5px 0;
    }
    .logout{
      &:hover{
        color: @blue;
      }
    }
  }
</style>
